import { Flex } from "@mantine/core";

import styles from "./AudioLevelIndicator.module.css";

interface AudioLevelIndicatorProps {
  level: number;
}

const BAR_COUNT = 5;

export const AudioLevelIndicator = ({ level }: AudioLevelIndicatorProps) => (
  <Flex align="center" className={styles.wrapper} gap={3}>
    {Array.from({ length: BAR_COUNT }, (_, i) => {
      const threshold = (i + 1) / BAR_COUNT;
      const isActive = level >= threshold * 0.8;
      return (
        <div
          className={styles.bar}
          data-active={isActive}
          key={i}
          style={{ height: `${12 + i * 4}px` }}
        />
      );
    })}
  </Flex>
);
